var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"price-wrapper mb-2"},[_c('div',{staticClass:"display-4 float-right"},[_c('small',[_vm._v("From:")]),_vm._v(" "+_vm._s(_vm.currency(_vm.activity.price.currencyCode))+_vm._s(_vm.formatPrice(_vm.activity.price.amount))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }